module.exports = __webpack_public_path__ + "img/product.64cdb4bf.png";